
export const compressImage = (file, maxWidth = 800, maxHeight = 800)=> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width *= maxHeight / height;
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob((blob:any) => {
                    blob.name = file.name.replace(/\.[^/.]+$/, ".jpg");
                    resolve(blob);
                }, 'image/jpeg');
            };
            // @ts-ignore
            img.src = e.target.result;
        };

        reader.readAsDataURL(file);
    });
}



